module.exports = __webpack_public_path__ + "static/lemonchickonesie4-28e68b8ed480eb2ff6865423be9ed98e.jpeg";